import { isEmpty } from 'lodash'
import { useRef } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import Button from '@/components/Button'
import { Error } from '@/components/Icons'
import Modal from '@/components/Modal'

import messages from './messages'

const Content = styled.div`
  padding: 60px 60px 0 60px;
  margin-bottom: 3rem;
`
const divRow = styled.div`
  display: flex;
`
const StyledRow = styled(divRow)`
  margin-bottom: 1.1rem;
  margin-top: 0;
  align-items: center;
`
const ButtonRow = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
`
const ErrorContainer = styled.div`
  display: flex;
  & svg {
    height: 1.5rem;
    width: 1.5rem;
  }
`
const WarningBlock = styled.div`
  display: flex;
  margin: 0.2rem 0 0 0.5rem;
  line-height: 1.2rem;
  font-weight: bold;
  font-size: 1.2rem;
`
const StyleParagraph = styled.p`
  font-size: 1em;
  margin: 0;
`
const FeatureNameList = styled.ul`
  padding-left: 3em;
  margin: 0;
  color: #4b4b4b;
`
const FeatureNameToDelete = styled.li`
  list-style-type: disc;
  padding-bottom: 10px;
`

interface StyledErrorWithInputProps {
  isOpen: boolean
  onClose: () => void
  featureNames: [] | string[]
  errorFrom?: string
}

const ErrorModal = ({ isOpen, onClose, featureNames, errorFrom }: StyledErrorWithInputProps) => {
  const intl = useIntl()

  const initialFocus = useRef(null)
  return (
    <Modal isOpen={isOpen} onClose={onClose} initialFocus={initialFocus}>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div onClick={event => event.stopPropagation()}>
        <Content>
          <StyledRow>
            <ErrorContainer>
              <Error />
            </ErrorContainer>
            <WarningBlock>
              <FormattedMessage
                {...messages[errorFrom === 'delete' ? 'cannotDeleteFeatureTitle' : 'cannotDeactivateFeatureTitle']}
              />
            </WarningBlock>
          </StyledRow>
          {!isEmpty(featureNames) && (
            <>
              <StyledRow>
                <StyleParagraph>
                  <FormattedMessage
                    {...messages['featureWarningSubMessage']}
                    values={{
                      featureText: featureNames.length > 1 ? 'There are features' : 'There is a feature',
                      featureGrammar: featureNames.length > 1 ? 'are' : 'is'
                    }}
                  />
                </StyleParagraph>
              </StyledRow>
              <StyledRow>
                <FeatureNameList>
                  {featureNames?.map((featureName: string, index: number) => (
                    <FeatureNameToDelete key={index}>{featureName}</FeatureNameToDelete>
                  ))}
                </FeatureNameList>
              </StyledRow>
            </>
          )}
        </Content>

        <ButtonRow>
          <Button
            ref={initialFocus}
            onClick={event => {
              event.stopPropagation()
              onClose()
            }}
            color={'secondary'}
          >
            {intl.formatMessage(messages.dismiss)}
          </Button>
        </ButtonRow>
      </div>
    </Modal>
  )
}

export default ErrorModal
